var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationVectorMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1539 5.07691C10.1539 8.30768 6.00004 11.0769 6.00004 11.0769C6.00004 11.0769 1.84619 8.30768 1.84619 5.07691C1.84619 3.97524 2.28383 2.9187 3.06282 2.1397C3.84182 1.3607 4.89837 0.923065 6.00004 0.923065C7.10171 0.923065 8.15825 1.3607 8.93725 2.1397C9.71625 2.9187 10.1539 3.97524 10.1539 5.07691Z",
    stroke: "#F1F1F1",
    strokeOpacity: 0.5,
    strokeWidth: 0.923077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00009 6.46155C6.7648 6.46155 7.38471 5.84164 7.38471 5.07694C7.38471 4.31224 6.7648 3.69232 6.00009 3.69232C5.23539 3.69232 4.61548 4.31224 4.61548 5.07694C4.61548 5.84164 5.23539 6.46155 6.00009 6.46155Z",
    stroke: "#F1F1F1",
    strokeOpacity: 0.5,
    strokeWidth: 0.923077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationVectorMuted);
export default __webpack_public_path__ + "static/media/locationVectorMuted.69dd0dbb845732946e21f43f823a180b.svg";
export { ForwardRef as ReactComponent };